import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment, API } from "@core/envs";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ValidationsService {
  private readonly http = inject(HttpClient);

  validateWhatsappContact(countryC: string, contactValue: string) {
    const api = environment.getRoute(API.users);
    const url = `${api}/customer/validation`;
    const body = {
      countryC,
      divisionK: 1,
      contactValue,
      channel: 'WHATSAPP',
      status: 'PENDING'
    };
    return this.http.post(url, body);
  }
}
